var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('label',{staticClass:"text-value"},[_vm._v(_vm._s(_vm.component.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }